(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["gg-dispatch-countdown"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('gg-dispatch-countdown')) {
    class GgDispatchCountdown extends HTMLElement {
      static formatter = new Intl.DateTimeFormat('en-GB', {
        timeZone: 'Europe/London', year: 'numeric', month: '2-digit', day: '2-digit',
        hour: '2-digit', minute: '2-digit', second: '2-digit', hourCycle: 'h23'
      });

      static parts(timestamp) {
        return Object.fromEntries(this.formatter.formatToParts(timestamp)
          .filter(part => part.type !== 'literal').map(part => [part.type, Number(part.value)]));
      }

      static state(timestamp) {
        const local = this.parts(timestamp);
        const desired = Date.UTC(local.year, local.month - 1, local.day, 23);
        let deadline = desired;
        for (let attempt = 0; attempt < 3; attempt += 1) {
          const at = this.parts(deadline);
          deadline += desired - Date.UTC(at.year, at.month - 1, at.day, at.hour, at.minute, at.second);
        }
        return { closed: timestamp >= deadline, seconds: Math.max(0, Math.ceil((deadline - timestamp) / 1000)) };
      }

      connectedCallback() {
        this.message = this.querySelector('[data-dispatch-message]');
        this.clock = this.querySelector('[data-dispatch-clock]');
        if (!this.message || !this.clock) return;
        this.tick();
        this.interval = window.setInterval(() => { if (!document.hidden) this.tick(); }, 1000);
        this.onVisibility = () => this.tick();
        document.addEventListener('visibilitychange', this.onVisibility);
      }

      disconnectedCallback() {
        window.clearInterval(this.interval);
        document.removeEventListener('visibilitychange', this.onVisibility);
      }

      tick() {
        const state = GgDispatchCountdown.state(Date.now());
        this.message.textContent = state.closed ? this.dataset.closed : this.dataset.open;
        this.clock.hidden = state.closed;
        if (!state.closed) {
          this.clock.textContent = [Math.floor(state.seconds / 3600), Math.floor(state.seconds % 3600 / 60), state.seconds % 60]
            .map(value => String(value).padStart(2, '0')).join(':');
        }
      }
    }
    customElements.define('gg-dispatch-countdown', GgDispatchCountdown);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["gg-mobile-purchase"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('gg-mobile-purchase')) {
    customElements.define('gg-mobile-purchase', class extends HTMLElement {
      connectedCallback() {
        this.root = this.closest('.shopify-section');
        this.form = this.root?.querySelector(`product-form-component[data-product-id="${this.dataset.productId}"] form`);
        this.picker = this.root?.querySelector(`variant-picker[data-product-id="${this.dataset.productId}"]`);
        this.action = this.querySelector('[data-purchase-action]');
        this.price = this.querySelector('[data-purchase-price]');
        this.selection = this.querySelector('[data-purchase-selection]');
        if (!this.form || !this.nativeButton || !this.action || !this.price || !this.selection) return;
        this.confirmed = this.dataset.defaultVariant === 'true' || new URL(location.href).searchParams.get('variant') === this.dataset.variantId;
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        this.pending = false;
        this.action.addEventListener('click', () => this.purchase(), options);
        this.root.addEventListener('click', event => this.confirmChoice(event), options);
        this.root.addEventListener('change', event => this.confirmChoice(event), options);
        this.root.addEventListener('variant:selected', event => {
          if (event.target !== this.picker) return;
          this.pending = true;
          this.sync();
        }, options);
        this.root.addEventListener('variant:update', event => {
          if (String(event.detail.data.productId) !== this.dataset.productId) return;
          const incoming = event.detail.data.html.querySelector(`gg-mobile-purchase[data-product-id="${this.dataset.productId}"]`);
          if (incoming) {
            this.dataset.price = incoming.dataset.price;
            this.dataset.variantTitle = incoming.dataset.variantTitle;
            this.dataset.variantId = incoming.dataset.variantId;
          }
          this.pending = false;
          queueMicrotask(() => this.sync());
        }, options);
        this.observer = new MutationObserver(() => this.sync());
        this.observer.observe(this.form, { subtree: true, childList: true, attributes: true, attributeFilter: ['disabled'] });
        this.onScroll = () => {
          if (this.frame) return;
          this.frame = requestAnimationFrame(() => { this.frame = null; this.visibility(); });
        };
        window.addEventListener('scroll', this.onScroll, { ...options, passive: true });
        window.addEventListener('resize', this.onScroll, options);
        document.addEventListener('cart:error', () => {
          if (this.usedShortcut) { this.usedShortcut = false; this.scrollTo(this.form); }
        }, options);
        document.addEventListener('cart:update', () => { this.usedShortcut = false; }, options);
        this.dataset.ready = 'true';
        this.sync();
      }

      disconnectedCallback() {
        this.controller?.abort();
        this.observer?.disconnect();
        cancelAnimationFrame(this.frame);
      }

      get nativeButton() { return this.form?.querySelector('button[ref="addToCartButton"]'); }

      confirmChoice(event) {
        const input = event.target.closest('input[type="radio"], select');
        if (!input || input.closest('variant-picker') !== this.picker) return;
        const option = input.tagName === 'SELECT' ? input.selectedOptions[0] : input;
        const position = Number(option?.dataset.inputId?.split('-')[0]);
        if (Number(this.dataset.sizePosition) === 0 || position === Number(this.dataset.sizePosition)) this.confirmed = true;
        queueMicrotask(() => this.sync());
      }

      scrollTo(element) {
        element?.scrollIntoView({ block: 'center', behavior: 'instant' });
        element?.querySelector('input:not([type="hidden"]):not(:disabled), select, button:not(:disabled)')?.focus({ preventScroll: true });
      }

      purchase() {
        if (!this.confirmed) { this.scrollTo(this.picker || this.form); return; }
        if (this.pending || !this.nativeButton || this.nativeButton.disabled) return;
        if (this.form.querySelector('[name="id"]')?.value !== this.dataset.variantId) { this.scrollTo(this.form); return; }
        this.usedShortcut = true;
        this.nativeButton.click();
        queueMicrotask(() => {
          const error = this.form.querySelector('[ref="addToCartTextError"]:not(.hidden)');
          if (error) { this.usedShortcut = false; this.scrollTo(this.form); }
        });
      }

      sync() {
        const native = this.nativeButton;
        this.price.textContent = this.dataset.price;
        this.selection.textContent = this.confirmed ? this.dataset.variantTitle : this.dataset.choose;
        this.action.textContent = this.pending ? this.dataset.updating : !this.confirmed ? this.dataset.choose : native?.disabled ? this.dataset.unavailable : this.dataset.add;
        this.action.disabled = this.pending || (this.confirmed && (!native || native.disabled));
        this.visibility();
      }

      visibility() {
        const native = this.nativeButton;
        this.hidden = !native || native.getBoundingClientRect().bottom >= 0 || window.innerWidth > 749;
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
